import React from "react";
import styles from "./Curriculum.module.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
const Curriculum = () => {
  return (
    <>
    <Helmet>
      <title>Curriculum - Saraswati Vidya Mandir</title>
      <meta name="description" content="Discover the comprehensive curriculum at Saraswati Vidya Mandir, offering education from Nursery to Class 12 with a focus on holistic development and academic excellence." />
    </Helmet> 

    <div className={styles.curriculumPage}>

      {/* HERO */}
      <section className={styles.hero}>
        <h1>Our Curriculum</h1>
        <p>Nursery to Class 12 – Building Strong Foundations for Life</p>
      </section>

      {/* INTRO */}
      <section className={styles.intro}>
        <h2>Holistic Learning Approach</h2>
        <p>
          At Saraswati Vidya Mandir, we follow a well-structured curriculum
          designed to nurture intellectual, emotional, physical, and social
          development of every student. Our education system blends academics
          with values, creativity, discipline, and practical learning.
        </p>
      </section>

    

{/* CLASSES */}
<section className={styles.gridSection}>

  <div className={styles.card}>
    <div className={styles.icon}>🎒</div>
    <h3>Nursery – UKG</h3>
    <p>
      Play-based learning with alphabets, numbers, rhymes, storytelling
      and creative activities to build early childhood foundation.
    </p>
  </div>

  <div className={styles.card}>
    <div className={styles.icon}>📘</div>
    <h3>Class 1 – 5 (Primary)</h3>
    <p>
      Strong foundation in English, Hindi, Maths & EVS with interactive
      learning and activity-based teaching methods.
    </p>
  </div>

  <div className={styles.card}>
    <div className={styles.icon}>🔬</div>
    <h3>Class 6 – 8 (Middle)</h3>
    <p>
      Introduction to Science, Social Studies, Computer education with
      focus on analytical thinking and practical knowledge.
    </p>
  </div>

  <div className={styles.card}>
    <div className={styles.icon}>📊</div>
    <h3>Class 9 – 10 (Secondary)</h3>
    <p>
      Board exam preparation with strong focus on Maths, Science & English
      for academic excellence.
    </p>
  </div>

  <div className={styles.card}>
    <div className={styles.icon}>🎓</div>
    <h3>Class 11 – 12</h3>
    <p>
      Streams: Science, Commerce & Arts with career-oriented learning for
      higher education and competitive exams.
    </p>
  </div>

</section>

     {/* FEATURES */}
<section className={styles.features}>

  <h2 className={styles.title}>Key Highlights</h2>
  <p className={styles.subtitle}>
    Why Saraswati Vidya Mandir stands out in education
  </p>

  <div className={styles.featureGrid}>

    <div className={styles.featureCard}>
      <span>📘</span>
      <p>NCERT-based curriculum</p>
    </div>

    <div className={styles.featureCard}>
      <span>🖥️</span>
      <p>Smart classroom teaching</p>
    </div>

    <div className={styles.featureCard}>
      <span>📝</span>
      <p>Regular tests & assessments</p>
    </div>

    <div className={styles.featureCard}>
      <span>🎨</span>
      <p>Activity-based learning</p>
    </div>

    <div className={styles.featureCard}>
      <span>🧠</span>
      <p>Moral & value education</p>
    </div>

    <div className={styles.featureCard}>
      <span>🏆</span>
      <p>Sports & extracurricular</p>
    </div>

  </div>

</section>

   
 {/* 🚀 PREMIUM CTA */}
<section className={styles.ctaSection}>
  <div className={styles.overlay}></div>

  <div className={styles.ctaContent}>
    <h2>Shape Your Child’s Bright Future Today</h2>

    <p>
      Join Saraswati Vidya Mandir and give your child the perfect blend of
      knowledge, discipline, and values.
    </p>

    <div className={styles.ctaBtns}>
      <Link to="/contact">
        <button className={styles.primaryBtn}>Apply Now</button>
      </Link>
      <button className={styles.secondaryBtn}>Explore More</button>
    </div>
  </div>
</section>

    </div>
    </>
  );
};

export default Curriculum;